import {
    Alert,
    Autocomplete,
    Button,
    Grid,
    Stack,
    TextField,
    Tooltip,
    Typography,
    useMediaQuery,
    useTheme,
  } from '@mui/material';
  import React, { useState } from 'react';
  import { goal_list } from 'src/utils/goals-data';
  import CheckCircleIcon from '@mui/icons-material/CheckCircle';
  import Snackbar from '@mui/material/Snackbar';
  
  function CopyGoalWidget() {
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.up('md'));
    const [selectedGoal, setSelectedGoal] = useState<any>(null);
    const [copiedText, setCopiedText] = useState<any>({
      name: '',
      copiedText: '',
    });
  
    const handleSelectGoal = (e: any, value: any) => {
      setSelectedGoal(value);
    };
  
    const [openSnack, setOpenSnack] = useState<boolean>(false);
    const handleCloseSnack = () => {
      setOpenSnack(false);
    };
    const handleOpenSnack = () => {
      setOpenSnack(true);
    };
  
    const handleCopyText = (option: any, text: string) => {
      setSelectedGoal(option);
      navigator.clipboard
        .writeText(text)
        .then(() => {
          setCopiedText({
            name: option.GoalName,
            copiedtext: text,
          });
          handleOpenSnack();
        })
        .catch((e) => {
          console.error('Error in copy the text ', e);
        });
    };
  
    return (
      <>
        <Stack
          sx={{ width: isSmallScreen ? '30ch' : '50ch' }}
          mr={5}
          ml={isSmallScreen ? 8 : 0}
        >
          <Typography fontWeight={600}>Goal Widget</Typography>
          <Autocomplete
            freeSolo
            value={selectedGoal || { GoalName: '' }}
            getOptionLabel={(option: any) => option.GoalName}
            options={goal_list}
            fullWidth
            onChange={(e, value) => handleSelectGoal(e, value)}
            renderOption={(props, option) => (
              <Grid sx={{ boxShadow: '0px 0px 0px 1px #F2F4F7', border: '1px solid #E5E7EB' }}>
                <Typography {...props}>{option.GoalName}</Typography>
                {option.CurrentGoalText && (
                  <Tooltip
                    title={option.CurrentGoalText}
                    placement="right"
                    arrow
                  >
                    <Button
                      onClick={() => handleCopyText(option, option.CurrentGoalText)}
                      endIcon={
                        copiedText.name === option.GoalName &&
                        copiedText.copiedtext === option.CurrentGoalText && <CheckCircleIcon />
                      }
                    >
                      Current Status
                    </Button>
                  </Tooltip>
                )}
  
                {option.TargetGoalText && (
                  <Tooltip
                    title={option.TargetGoalText}
                    placement="right"
                    arrow
                  >
                    <Button
                      endIcon={
                        copiedText.name === option.GoalName &&
                        copiedText.copiedtext === option.TargetGoalText && <CheckCircleIcon />
                      }
                      onClick={() => handleCopyText(option, option.TargetGoalText)}
                    >
                      Target Status
                    </Button>
                  </Tooltip>
                )}
              </Grid>
            )}
            renderInput={(params) => {
              return (
                <TextField
                  {...params}
                  name="Goals"
                  fullWidth
                  placeholder='Search Goal'
                />
              );
            }}
          />
        </Stack>
  
        <Snackbar
          open={openSnack}
          autoHideDuration={6000}
          onClose={handleCloseSnack}
        >
          <Alert
            onClose={handleCloseSnack}
            severity="success"
            variant="filled"
            sx={{ width: '100%' }}
          >
            Copied
          </Alert>
        </Snackbar>
      </>
    );
  }
  
  export default CopyGoalWidget;
